import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import CustomModal from "./modal";
import MakeAPICall from "../apiCalls/common";
import { mimsEndUserLicenseAgreementApiRoute } from "../apiRoutes";
import { updateMimsEulaRevision } from "../reduxStore/actions/auth";

class EulaPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEulaModal: false,
      eulaData: null,
      eulaAPICall: null
    };
  }

  componentDidUpdate(prevProps) {
    // Trigger EULA check when constants are loaded for the first time
    if (!prevProps.shouldCheckEula && this.props.shouldCheckEula) {
      this.checkAndShowEulaModal();
    }
  }

  checkAndShowEulaModal = () => {
    // Compare constants vs auth data to determine if popups should show
    const constantsEulaDate = this.props.constants?.mimsConfig?.endUserLicenseAgreementRevisionDate;
    const authEulaAcceptedDate = this.props.auth?.user?.userData?.mimsData?.endUserLicenseAgreement?.acceptedDate;

    console.log('Constants EULA date:', constantsEulaDate);
    console.log('Auth EULA accepted date:', authEulaAcceptedDate);

    // Check EULA first: show if constants date > user's accepted date
    // Priority: Redux state > auth accepted date
    const userAcceptedEulaDate = this.props.mimsEulaRevision || authEulaAcceptedDate;
    const shouldShowEula = !userAcceptedEulaDate || (constantsEulaDate && moment(constantsEulaDate).isAfter(moment(userAcceptedEulaDate)));

    console.log('Should show EULA:', shouldShowEula);

    if (shouldShowEula) {
      // Fetch EULA content for display
      this.fetchEulaData();
    }
  }

  fetchEulaData = () => {
    const apiCallParam = {
      reqType: "GET",
      reqURL: mimsEndUserLicenseAgreementApiRoute,
      dataObj: {},
      params: {},
      headers: {},
      successCallback: res => {
        // We've already determined this should be shown in checkAndShowEulaModal
        this.setState({
          eulaData: res.data.data.agreement,
          showEulaModal: true
        });
      },
      failureCallback: err => {
        console.log("Failed to fetch EULA data: ", err);
        this.setState({ showEulaModal: true });
      },
      showPopUp: false
    };
    this.setState({
      eulaAPICall: apiCallParam
    });
  }

  handleEulaAccept = () => {
    // Store the constants revision date in Redux only
    const constantsEulaDate = this.props.constants?.mimsConfig?.endUserLicenseAgreementRevisionDate;

    if (constantsEulaDate) {
      this.props.updateMimsEulaRevision(constantsEulaDate);
    }

    this.setState({ showEulaModal: false });
  }

  render() {
    return (
      <>
        <CustomModal
          openModal={this.state.showEulaModal}
          modalBodyContent={this.state.eulaData ? this.state.eulaData.eula : "Loading..."}
          title="End User License Agreement"
          cancelText="Accept"
          size="lg"
          className="eula-modal"
          useOneButton={true}
          backdrop={false}
          showCloseButton={false}
          cancelEvent={this.handleEulaAccept}
        />
        <MakeAPICall apiParam={this.state.eulaAPICall} />
      </>
    );
  }
}

const mapStateToProps = props => ({
  auth: props.auth,
  mimsEulaRevision: props.auth.mimsEulaRevision,
  constants: props.auth && props.auth.user && props.auth.user.appConstant
    ? props.auth.user.appConstant
    : {}
});

const mapDispatchToProps = dispatch => ({
  updateMimsEulaRevision: data => dispatch(updateMimsEulaRevision(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(EulaPopup);
